import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import loadable from '@loadable/component';
import { Switch, Route, useHistory } from 'react-router-dom';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconVerified from 'components/icons/iconVerified';
import Placeholder from 'components/consumer/Placeholder';
import BrowserOnly from 'components/consumer/BrowserOnly';
import getShortCustomerName from 'commons/getShortCustomerName';
import useScreen from 'hooks/useScreen';
import ReviewStars from 'components/consumer/ReviewStars';
import SanitizedHtml from 'components/consumer/SanitizedHtml';
import RatingAndReviews from '../../RatingAndReviews';
import PDPCustomerPhotosGrid from './PDPCustomerPhotosGrid';
const PDPCustomerPhotosReviewsModal = loadable(() => import('./PDPCustomerPhotosReviewsModal'));
const Comment = t0 => {
  const $ = _c(7);
  const {
    comment
  } = t0;
  if (comment && comment.length > 175) {
    let t1;
    if ($[0] !== comment) {
      t1 = comment.slice(0, 175);
      $[0] = comment;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <SanitizedHtml as="span" html={t1} />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <CtaButton styling="link" color="brand" size="sm" spacing="sm" hasArrow={false} className="normal-case hover:underline">Continue reading</CtaButton>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t2) {
      t4 = <>{t2}{"... "}{t3}</>;
      $[5] = t2;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  return comment;
};
Comment.propTypes = {
  comment: PropTypes.string
};
const PDPCustomerPhotosUI = t0 => {
  const $ = _c(99);
  const {
    id,
    name,
    loading,
    customerPhotos,
    customerReviews,
    pdpIsModularBYOProduct,
    selectedMaterial
  } = t0;
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(-1);
  const [selectedReviewIndex, setSelectedReviewIndex] = useState(-1);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  let t1;
  if ($[0] !== customerPhotos?.totalPhotos || $[1] !== customerReviews?.totalReviews) {
    t1 = () => {
      setTotalCount((customerPhotos?.totalPhotos || 0) + (customerReviews?.totalReviews || 0));
    };
    $[0] = customerPhotos?.totalPhotos;
    $[1] = customerReviews?.totalReviews;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== customerPhotos || $[4] !== customerReviews || $[5] !== pdpIsModularBYOProduct) {
    t2 = [pdpIsModularBYOProduct, customerPhotos, customerReviews];
    $[3] = customerPhotos;
    $[4] = customerReviews;
    $[5] = pdpIsModularBYOProduct;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== history) {
    t3 = () => {
      setSelectedPhotoIndex(-1);
      setSelectedReviewIndex(-1);
      const currentPath = window.location.pathname;
      if (currentPath.split("/").pop() === "customer-reviews") {
        history.replace(`${currentPath.substring(0, currentPath.lastIndexOf("/"))}/`);
        return;
      }
      history.goBack();
    };
    $[7] = history;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const toggleModal = t3;
  let t4;
  if ($[9] !== history) {
    t4 = () => {
      history.push("customer-reviews");
    };
    $[9] = history;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const openModal = t4;
  const {
    isMobile
  } = useScreen();
  customerReviews?.reviews;
  let t5;
  bb0: {
    if (customerReviews?.reviews.length) {
      let t6;
      if ($[11] !== customerReviews?.reviews || $[12] !== selectedMaterial) {
        const reviewForSelectedFabrics = customerReviews?.reviews.filter(review => review?.materials.includes(selectedMaterial.label));
        const reviewForOtherFabrics = customerReviews?.reviews.filter(review_0 => !review_0?.materials.includes(selectedMaterial.label));
        t6 = [...reviewForSelectedFabrics, ...reviewForOtherFabrics];
        $[11] = customerReviews?.reviews;
        $[12] = selectedMaterial;
        $[13] = t6;
      } else {
        t6 = $[13];
      }
      t5 = t6;
      break bb0;
    }
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = [];
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = t6;
  }
  const filteredReview = t5;
  let t6;
  if ($[15] !== customerPhotos?.photos || $[16] !== selectedMaterial) {
    t6 = () => {
      if (customerPhotos?.photos.length) {
        const reviewForSelectedFabrics_0 = customerPhotos?.photos.filter(review_1 => parseInt(review_1?.upholstery_id, 10) === selectedMaterial.materialId).map(_temp);
        const reviewForOtherFabrics_0 = customerPhotos?.photos.filter(review_2 => parseInt(review_2?.upholstery_id, 10) !== selectedMaterial.materialId).map(_temp2);
        return [...reviewForSelectedFabrics_0, ...reviewForOtherFabrics_0];
      }
      return [];
    };
    $[15] = customerPhotos?.photos;
    $[16] = selectedMaterial;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  customerPhotos?.photos;
  let t7;
  if ($[18] !== t6) {
    t7 = t6();
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const filteredPhotos = t7;
  if (loading) {
    let t8;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="text-xl font-bold mb-1 [&_svg]:ml-2 [&_svg_g]:stroke-[#107c8c]"><Placeholder type="rect" loading={true} style={{
          width: 331,
          height: 28
        }} /></div>;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div><Placeholder type="rect" loading={true} style={{
          width: 174,
          height: 26
        }} /></div>;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="rounded overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:cursor-pointer [&_img]:object-cover [&_img]:[content-visibility:auto] [&_img]:[contain-intrinsic-size:0] PDPCustomerPhotosGrid__item1"><div className="w-full h-full"><Placeholder type="rect" loading={true} /></div></div>;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="rounded overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:cursor-pointer [&_img]:object-cover [&_img]:[content-visibility:auto] [&_img]:[contain-intrinsic-size:0] PDPCustomerPhotosGrid__item2"><div className="w-full h-full"><Placeholder type="rect" loading={true} /></div></div>;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <div className="rounded overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:cursor-pointer [&_img]:object-cover [&_img]:[content-visibility:auto] [&_img]:[contain-intrinsic-size:0] PDPCustomerPhotosGrid__item3"><div className="w-full h-full"><Placeholder type="rect" loading={true} /></div></div>;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="rounded overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:cursor-pointer [&_img]:object-cover [&_img]:[content-visibility:auto] [&_img]:[contain-intrinsic-size:0] PDPCustomerPhotosGrid__item4"><div className="w-full h-full"><Placeholder type="rect" loading={true} /></div></div>;
      $[25] = t13;
    } else {
      t13 = $[25];
    }
    let t14;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="grid gap-[.5rem] mt-4 mb-2 grid-cols-[repeat(4,calc(25%_-_.5rem)_)] grid-rows-[repeat(2,100px)] justify-center content-end [content-visibility:auto] [contain-intrinsic-size:0] PDPCustomerPhotosGrid__layout-5">{t10}{t11}{t12}{t13}<div className="rounded overflow-hidden [&_img]:w-full [&_img]:h-full [&_img]:cursor-pointer [&_img]:object-cover [&_img]:[content-visibility:auto] [&_img]:[contain-intrinsic-size:0] PDPCustomerPhotosGrid__item5"><div className="w-full h-full"><Placeholder type="rect" loading={true} /></div></div></div>;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    let t15;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = [1, 2];
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    let t16;
    if ($[28] !== isMobile) {
      t16 = <div className="mt-6 mx-0 mb-2">{t15.map(item => <React.Fragment key={`PDPCustomerPhotos__list${item}`}><div className="relative flex cursor-pointer mx-0 my-8 max-[767px]:flex-col [&_img]:rounded-lg mb-8 pt-8 px-0 pb-0 [border-top:1px_solid_#f6f6f6] first:[border-top:0] first:mt-0"><div className="flex-[0.33] max-[767px]:flex max-[767px]:flex-1"><div className="w-11 h-11 max-h-[3.75rem] text-2xl text-gray-light6 bg-gray-light8 rounded-full mr-4 mb-2 flex justify-center items-center"><Placeholder type="round" loading={true} style={{
                  width: 44,
                  height: 44
                }} /></div><div className="PDPCustomerPhotos__user-details"><div className="text-xl font-bold mb-1 [&_svg]:ml-2 [&_svg_g]:stroke-[#107c8c]"><Placeholder type="rect" loading={true} style={{
                    height: 14,
                    borderRight: !isMobile ? "57px solid white" : 0
                  }} /></div><div className="text-xs"><Placeholder type="rect" loading={true} style={{
                    height: 14,
                    borderRight: !isMobile ? "57px solid white" : 0
                  }} /></div></div></div><div className="md:flex-[0.75]"><div className="PDPCustomerPhotos__header"><div className="[&_svg]:w-3 [&_svg]:mr-[.325rem]"><Placeholder type="rect" loading={true} style={{
                    height: 14,
                    width: 75,
                    marginBottom: 13
                  }} /></div></div><div className="text-lg font-bold mt-[.325rem]"><Placeholder type="rect" loading={true} style={{
                  height: 26,
                  width: 252,
                  marginBottom: 14
                }} /></div><div className="text-sm mt-[.325rem]"><Placeholder type="rect" loading={true} style={{
                  height: 14,
                  marginBottom: 7
                }} /><Placeholder type="rect" loading={true} style={{
                  height: 14,
                  marginBottom: 7
                }} /><Placeholder type="rect" loading={true} style={{
                  height: 14,
                  marginBottom: 7
                }} /><Placeholder type="rect" loading={true} style={{
                  height: 14
                }} /></div></div></div></React.Fragment>)}</div>;
      $[28] = isMobile;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    let t17;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <Placeholder type="rect" loading={true} style={{
        height: 44,
        marginTop: 46
      }} />;
      $[30] = t17;
    } else {
      t17 = $[30];
    }
    let t18;
    if ($[31] !== t16) {
      t18 = <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]" id="PDPCustomerPhotos">{t8}{t9}{t14}{t16}{t17}</div>;
      $[31] = t16;
      $[32] = t18;
    } else {
      t18 = $[32];
    }
    return t18;
  }
  if (!totalCount) {
    let t8;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="PDPCustomerPhotosUI__filler" />;
      $[33] = t8;
    } else {
      t8 = $[33];
    }
    return t8;
  }
  let t8;
  if ($[34] !== filteredPhotos) {
    t8 = filteredPhotos || [];
    $[34] = filteredPhotos;
    $[35] = t8;
  } else {
    t8 = $[35];
  }
  const photos = t8;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t9;
  if ($[36] !== customerPhotos?.totalPhotos || $[37] !== customerReviews || $[38] !== filteredReview || $[39] !== name || $[40] !== openModal || $[41] !== photos || $[42] !== totalCount) {
    const reviews = filteredReview || [];
    t11 = "[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]";
    t12 = "PDPCustomerPhotos";
    if ($[50] !== name) {
      t13 = name && <h2 className="text-xl font-bold mb-1 [&_svg]:ml-2 [&_svg_g]:stroke-[#107c8c]">Customers love the {name}</h2>;
      $[50] = name;
      $[51] = t13;
    } else {
      t13 = $[51];
    }
    if ($[52] !== customerReviews || $[53] !== totalCount) {
      t14 = customerReviews && <div className="mb-6"><RatingAndReviews numberOfReviews={totalCount} rating={customerReviews.averageRating} size="sm" /></div>;
      $[52] = customerReviews;
      $[53] = totalCount;
      $[54] = t14;
    } else {
      t14 = $[54];
    }
    const t16 = customerPhotos?.totalPhotos || 0;
    let t17;
    if ($[55] !== openModal) {
      t17 = idx => {
        setSelectedPhotoIndex(idx);
        openModal();
      };
      $[55] = openModal;
      $[56] = t17;
    } else {
      t17 = $[56];
    }
    if ($[57] !== photos || $[58] !== t16 || $[59] !== t17) {
      t15 = <PDPCustomerPhotosGrid photos={photos} totalPhotos={t16} onPhotoClick={t17} />;
      $[57] = photos;
      $[58] = t16;
      $[59] = t17;
      $[60] = t15;
    } else {
      t15 = $[60];
    }
    t9 = "mt-6 mx-0 mb-2";
    t10 = reviews.slice(0, 2).map((review_3, idx_0) => <React.Fragment key={`PDPCustomerPhotos__listItem${review_3.id}`}><div className="relative flex cursor-pointer mx-0 my-8 max-[767px]:flex-col [&_img]:rounded-lg" onClick={() => {
        setSelectedReviewIndex(idx_0);
        openModal();
      }}><div className="flex-[0.33] max-[767px]:flex max-[767px]:flex-1"><div className="w-11 h-11 max-h-[3.75rem] text-2xl text-gray-light6 bg-gray-light8 rounded-full mr-4 mb-2 flex justify-center items-center">{review_3.full_name?.[0]}</div><div className="PDPCustomerPhotos__user-details"><div className="text-xl font-bold mb-1 [&_svg]:ml-2 [&_svg_g]:stroke-[#107c8c] flex items-center justify-start"><span className="text-sm font-bold">{getShortCustomerName(review_3.full_name)}</span><IconVerified /></div><div className="text-xs">{review_3.location}</div></div></div><div className="md:flex-[0.75]"><div className="PDPCustomerPhotos__header"><ReviewStars rating={parseInt(review_3.rate, 10)} readOnly={true} size="xs" /><div className="text-xs absolute top-0 right-0">{format(new Date(review_3.date), "MMM dd, yyyy")}</div></div><SanitizedHtml className="text-lg font-bold mt-[.325rem]" html={review_3.title} /><div className="text-sm mt-[.325rem]"><Comment comment={review_3.comment} /></div></div></div>{idx_0 === 0 && <div className="[border-top:1px_solid_#f6f6f6]" />}</React.Fragment>);
    $[36] = customerPhotos?.totalPhotos;
    $[37] = customerReviews;
    $[38] = filteredReview;
    $[39] = name;
    $[40] = openModal;
    $[41] = photos;
    $[42] = totalCount;
    $[43] = t10;
    $[44] = t11;
    $[45] = t12;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
    $[49] = t9;
  } else {
    t10 = $[43];
    t11 = $[44];
    t12 = $[45];
    t13 = $[46];
    t14 = $[47];
    t15 = $[48];
    t9 = $[49];
  }
  let t16;
  if ($[61] !== t10 || $[62] !== t9) {
    t16 = <div className={t9}>{t10}</div>;
    $[61] = t10;
    $[62] = t9;
    $[63] = t16;
  } else {
    t16 = $[63];
  }
  let t17;
  if ($[64] !== openModal || $[65] !== totalCount) {
    t17 = totalCount > 0 && <CtaButton styling="solid-button" color="brand" onClick={openModal} className="w-full rounded-sm px-6 py-2" textClassName="!normal-case">See all {totalCount} reviews and photos</CtaButton>;
    $[64] = openModal;
    $[65] = totalCount;
    $[66] = t17;
  } else {
    t17 = $[66];
  }
  let t18;
  if ($[67] !== t11 || $[68] !== t12 || $[69] !== t13 || $[70] !== t14 || $[71] !== t15 || $[72] !== t16 || $[73] !== t17) {
    t18 = <div className={t11} id={t12}>{t13}{t14}{t15}{t16}{t17}</div>;
    $[67] = t11;
    $[68] = t12;
    $[69] = t13;
    $[70] = t14;
    $[71] = t15;
    $[72] = t16;
    $[73] = t17;
    $[74] = t18;
  } else {
    t18 = $[74];
  }
  let t19;
  if ($[75] !== customerReviews.averageRating || $[76] !== id || $[77] !== name || $[78] !== selectedMaterial || $[79] !== selectedPhotoIndex || $[80] !== selectedReviewIndex || $[81] !== toggleModal || $[82] !== totalCount) {
    t19 = <Route path="/modular/:slug/customer-reviews" exact={true}><BrowserOnly><PDPCustomerPhotosReviewsModal productId={id} productName={name} toggleModal={toggleModal} totalReviews={totalCount} imgIndex={selectedPhotoIndex} reviewIndex={selectedReviewIndex} averageRating={customerReviews.averageRating} selectedMaterial={selectedMaterial} /></BrowserOnly></Route>;
    $[75] = customerReviews.averageRating;
    $[76] = id;
    $[77] = name;
    $[78] = selectedMaterial;
    $[79] = selectedPhotoIndex;
    $[80] = selectedReviewIndex;
    $[81] = toggleModal;
    $[82] = totalCount;
    $[83] = t19;
  } else {
    t19 = $[83];
  }
  let t20;
  if ($[84] !== customerReviews.averageRating || $[85] !== id || $[86] !== name || $[87] !== selectedMaterial || $[88] !== selectedPhotoIndex || $[89] !== selectedReviewIndex || $[90] !== toggleModal || $[91] !== totalCount) {
    t20 = <Route path="/:category/:slug/customer-reviews"><BrowserOnly><PDPCustomerPhotosReviewsModal productId={id} productName={name} toggleModal={toggleModal} totalReviews={totalCount} imgIndex={selectedPhotoIndex} reviewIndex={selectedReviewIndex} averageRating={customerReviews.averageRating} selectedMaterial={selectedMaterial} /></BrowserOnly></Route>;
    $[84] = customerReviews.averageRating;
    $[85] = id;
    $[86] = name;
    $[87] = selectedMaterial;
    $[88] = selectedPhotoIndex;
    $[89] = selectedReviewIndex;
    $[90] = toggleModal;
    $[91] = totalCount;
    $[92] = t20;
  } else {
    t20 = $[92];
  }
  let t21;
  if ($[93] !== t19 || $[94] !== t20) {
    t21 = <Switch>{t19}{t20}</Switch>;
    $[93] = t19;
    $[94] = t20;
    $[95] = t21;
  } else {
    t21 = $[95];
  }
  let t22;
  if ($[96] !== t18 || $[97] !== t21) {
    t22 = <>{t18}{t21}</>;
    $[96] = t18;
    $[97] = t21;
    $[98] = t22;
  } else {
    t22 = $[98];
  }
  return t22;
};
PDPCustomerPhotosUI.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  loading: PropTypes.bool,
  customerReviews: PropTypes.shape({
    reviews: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      comment: PropTypes.string,
      date: PropTypes.string,
      full_name: PropTypes.string,
      location: PropTypes.string,
      rate: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })),
    totalReviews: PropTypes.number,
    averageRating: PropTypes.number
  }),
  customerPhotos: PropTypes.shape({
    totalPhotos: PropTypes.number,
    photos: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      url: PropTypes.string
    }))
  }),
  pdpIsModularBYOProduct: PropTypes.bool,
  selectedMaterial: PropTypes.object
};
export default PDPCustomerPhotosUI;
function _temp(image) {
  return {
    ...image,
    url: image.url?.split("main_").join("")
  };
}
function _temp2(image_0) {
  return {
    ...image_0,
    url: image_0.url?.split("main_").join("")
  };
}